'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TaskEditorViewStore = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _layoutComponent = require('layout-component');

var _simboxEditable = require('simbox-editable');

var _editor = require('simbox-editable/editor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var TaskEditorViewStore = exports.TaskEditorViewStore = (_dec = _mobx.action.bound, (_class = function (_EditorViewStore) {
  (0, _inherits3.default)(TaskEditorViewStore, _EditorViewStore);

  function TaskEditorViewStore() {
    (0, _classCallCheck3.default)(this, TaskEditorViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TaskEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(TaskEditorViewStore)).apply(this, arguments));

    var cm = _this.props.contentModel;
    var rxns = [];
    rxns.push((0, _mobx.reaction)(function () {
      return cm.id;
    }, function () {
      if (cm.activity) cm.activity.id = cm.id + "_activity";
    }), (0, _mobx.reaction)(function () {
      return cm.activityType;
    }, function () {
      return cm.createActivity();
    }));
    _this.dispose = function () {
      return rxns.forEach(function (rxn) {
        return rxn();
      });
    };
    return _this;
  }

  (0, _createClass3.default)(TaskEditorViewStore, [{
    key: 'handleExisting',
    value: function handleExisting(e, parent, name) {
      var item = parent.$parent.entities.get(e.target.value) /* || new parent.slots[name]({isNew: true, autoPopulate: true} )*/;
      if (!item) throw new Error("no item");
      parent.updateValue(name, item);
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.props.contentModel;
      var ret = contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var _subCm = contentModel[name];
          if (!_subCm) return acc;
          if (_subCm.contentModel) debugger;
          acc[_subCm.id] = {
            id: _subCm.id,
            contentModel: _subCm.contentModel || _subCm
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          contentModel[name].forEach(function (subCm) {
            if (!(subCm instanceof _baseContentmodel2.default)) return;
            if (subCm.contentModel) debugger;
            acc[subCm.id] = {
              id: subCm.id,
              contentModel: subCm.contentModel || subCm
            };
          });
        }
        return acc;
      }, {});

      var subCm = contentModel.activity;
      if (!subCm) return ret;
      if (subCm.activityContentModel) debugger;
      ret[subCm.id] = {
        id: subCm.id,
        contentModel: subCm.activityContentModel || subCm
      };

      return ret;
    }
  }]);
  return TaskEditorViewStore;
}(_editor.EditorViewStore), (_applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleExisting', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleExisting'), _class.prototype)), _class));

var TaskEditor = (0, _simboxEditable.Decorator)(_class2 = (0, _mobxReact.observer)(_class2 = (_temp = _class3 = function (_BaseComponent) {
  (0, _inherits3.default)(TaskEditor, _BaseComponent);

  function TaskEditor() {
    (0, _classCallCheck3.default)(this, TaskEditor);
    return (0, _possibleConstructorReturn3.default)(this, (TaskEditor.__proto__ || (0, _getPrototypeOf2.default)(TaskEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(TaskEditor, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editorViewStore = _props.editorViewStore,
          contentModel = _props.contentModel,
          _props$contentModel = _props.contentModel,
          allCms = _props$contentModel.allCms,
          allInputs = _props$contentModel.allInputs,
          activity = _props$contentModel.activity,
          isNew = _props$contentModel.isNew,
          updateValue = _props$contentModel.updateValue,
          invalid = _props$contentModel.invalid,
          activityType = _props$contentModel.activityType,
          description = _props$contentModel.description,
          displayTitle = _props$contentModel.displayTitle,
          id = _props$contentModel.id,
          createActivity = _props$contentModel.createActivity,
          slots = _props$contentModel.slots,
          options = _props.options,
          _onSave = _props.options.onSave,
          viewStore = _props.viewStore;
      var _viewStore = this.viewStore,
          handleExisting = _viewStore.handleExisting,
          SelectedView = _viewStore.SelectedView,
          clearView = _viewStore.clearView,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          isRoot = _viewStore.isRoot;

      // @TODO need autopopulation view in default editor for CMs

      return _react2.default.createElement(
        'div',
        null,
        isRoot && !!viewBreadcrumbs.length && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        SelectedView ? _react2.default.createElement(SelectedView, null) : _react2.default.createElement(
          'div',
          null,
          (0, _editor.createEditorElement)("id", slots, contentModel),
          isNew ? (0, _editor.createEditorElement)("activityType", slots, contentModel) : _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Type:'
            ),
            ' ',
            activityType.id
          ),
          activityType && (!activity || activity.isNew) && _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Id:'
            ),
            ' ',
            activity && activity.id,
            _react2.default.createElement(
              'div',
              null,
              invalid.activity && _react2.default.createElement(
                'div',
                { className: 'validation errorMessage' },
                invalid.activity
              ),
              allCms.map(function (data) {
                var cm = data[0];
                var parent = data[1];
                var name = data[2];
                var type = parent.slots[name].name;
                return _react2.default.createElement(
                  'div',
                  null,
                  cm.isNew && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'editor-label' },
                      name,
                      ': ',
                      cm.id
                    ),
                    !!cm.allOfSameType.length && _react2.default.createElement(
                      'div',
                      null,
                      'Select existing ',
                      type,
                      ' ',
                      _react2.default.createElement(
                        'select',
                        { onChange: function onChange(e) {
                            return handleExisting(e, parent, name);
                          } },
                        _react2.default.createElement('option', null),
                        cm.allOfSameType.map(function (cm) {
                          return _react2.default.createElement(
                            'option',
                            { key: cm.id },
                            cm.id
                          );
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Create new ',
                        type,
                        ':'
                      ),
                      _react2.default.createElement('input', { value: cm.id, onChange: function onChange(e) {
                          return cm.updateValue("id", e.target.value);
                        } }),
                      _react2.default.createElement(
                        'button',
                        { onClick: function onClick(e) {
                            return cm.saveEntity();
                          } },
                        'save'
                      )
                    )
                  )
                );
              })
            )
          ),
          activityType && activity && !activity.isNew && (0, _editor.createEditorElement)("activity", slots, contentModel, this.viewStore, options),
          (0, _editor.createEditorElement)("required", slots, contentModel),
          (0, _editor.createEditorElement)("displayTitle", slots, contentModel),
          (0, _editor.createEditorElement)("description", slots, contentModel),
          !!activity && _react2.default.createElement(
            'div',
            { className: 'editable-group' },
            _react2.default.createElement(
              'span',
              { className: 'editor-label' },
              'Activity Variables:'
            ),
            ' ',
            (0, _keys2.default)(allInputs).map(function (i) {
              return _react2.default.createElement(
                'div',
                { key: i },
                i
              );
            })
          ),
          _react2.default.createElement(_editor.ActionBar, { contentModel: contentModel, onSave: function onSave(e) {
              return activity.saveEntity(function () {
                return typeof _onSave === "function" && _onSave(e);
              });
            } })
        )
      );
    }
  }]);
  return TaskEditor;
}(_baseComponent2.default), _class3.ViewStore = TaskEditorViewStore, _temp)) || _class2) || _class2;

exports.default = TaskEditor;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TaskEditorViewStore, 'TaskEditorViewStore', 'src/entity_modules/task-entity/editor.js');

  __REACT_HOT_LOADER__.register(TaskEditor, 'TaskEditor', 'src/entity_modules/task-entity/editor.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/task-entity/editor.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/task-entity/editor.js
// module chunks = 0